<div class="applications-container">

  <!-- Blue Header Banner -->
  <div class="applications-header">
    <h2>College Applications</h2>
  </div>
  <!-- Regular View: Phase Tracker & Table -->
  <ng-container *ngIf="applications.length > 0 || isLoading">
    <!-- Phase Tracker - matching operations portal style -->
    <div class="phase-tracker">
      <div class="phase-item" [class.active]="activePhase === 1" (click)="selectPhase(1)">
        <div class="phase-top">
          <div class="phase-icon phase-icon--purple">
            <i class="pi pi-file-edit"></i>
          </div>
          <div class="phase-text">
            <span class="phase-label">1. Application Phase</span>
          </div>
        </div>
      </div>

      <div class="phase-item" [class.active]="activePhase === 2" (click)="selectPhase(2)">
        <div class="phase-top">
          <div class="phase-icon phase-icon--orange">
            <i class="pi pi-envelope"></i>
          </div>
          <div class="phase-text">
            <span class="phase-label">2. Offer Phase</span>
          </div>
        </div>
      </div>

      <div class="phase-item" [class.active]="activePhase === 3" (click)="selectPhase(3)">
        <div class="phase-top">
          <div class="phase-icon phase-icon--teal">
            <i class="pi pi-credit-card"></i>
          </div>
          <div class="phase-text">
            <span class="phase-label">3. Financials &amp; Visa Docs</span>
          </div>
        </div>
      </div>

      <div class="phase-item" [class.active]="activePhase === 4" (click)="selectPhase(4)">
        <div class="phase-top">
          <div class="phase-icon phase-icon--red">
            <i class="pi pi-send"></i>
          </div>
          <div class="phase-text">
            <span class="phase-label">4. Visa &amp; Departure Phase</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading skeleton -->
    <div class="apps-table-wrapper" *ngIf="isLoading">
      <table class="skeleton-table">
        <tr>
          <th>University &amp; Course</th>
          <th>Country</th>
          <th>Deadline</th>
          <th>Application Status</th>
          <th>Decision Status</th>
          <th>History</th>
        </tr>
        <tr class="skeleton-row" *ngFor="let row of skeletonRows">
          <td>
            <div class="skeleton-uni">
              <p-skeleton shape="circle" size="2.5rem"></p-skeleton>
              <div class="skeleton-uni-text">
                <p-skeleton width="11rem" height="0.85rem"></p-skeleton>
                <p-skeleton width="7rem" height="0.7rem"></p-skeleton>
              </div>
            </div>
          </td>
          <td><p-skeleton width="4rem" height="0.85rem"></p-skeleton></td>
          <td><p-skeleton width="3.5rem" height="0.85rem"></p-skeleton></td>
          <td><p-skeleton width="6.5rem" height="1.4rem" borderRadius="999px"></p-skeleton></td>
          <td><p-skeleton width="2rem" height="0.85rem"></p-skeleton></td>
          <td><p-skeleton width="5.5rem" height="0.85rem"></p-skeleton></td>
        </tr>
      </table>
    </div>

    <!-- Applications Table -->
    <div class="apps-table-wrapper" *ngIf="!isLoading">
      <p-table [value]="filteredApplications" styleClass="apps-table" [paginator]="filteredApplications.length > 10"
        [rows]="10" responsiveLayout="scroll">

        <ng-template pTemplate="header">
          <tr>
            <th>University &amp; Course <i class="pi pi-arrow-down sort-icon"></i></th>
            <th>Country</th>
            <th>Deadline <i class="pi pi-arrow-down sort-icon"></i></th>
            <th>Application Status <i class="pi pi-arrow-down sort-icon"></i></th>
            <th>Decision Status</th>
            <th>History</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-app>
          <tr>
            <td>
              <div class="uni-cell">
                <div class="uni-logo"
                  [ngStyle]="!app.instituteLogo ? {'background': getInitialsBg(app.instituteName)} : {}">
                  <img *ngIf="app.instituteLogo" [src]="app.instituteLogo" [alt]="app.instituteName"
                    (error)="onLogoError($event, app)" class="uni-logo-img" />
                  <ng-container *ngIf="!app.instituteLogo">{{ getInitials(app.instituteName) }}</ng-container>
                </div>
                <div class="uni-info">
                  <span class="uni-name">{{ app.instituteName }}</span>
                  <span class="uni-sub">
                    {{ app.courseName || 'General Application' }}
                    <ng-container *ngIf="app.inTakeYear"> | {{ app.inTakeYear }}</ng-container>
                    <ng-container *ngIf="app.courseLevel !== null"> | {{ courseLevelLabel(app.courseLevel)
                      }}</ng-container>
                  </span>
                </div>
              </div>
            </td>
            <td>
              <span class="td-country">{{ app.countryName || '—' }}</span>
            </td>
            <td>
              <span class="td-deadline">{{ app.inTakeYear || '—' }}</span>
            </td>
            <td>
              <div class="status-cell">
                <span class="status-badge" [ngClass]="statusBadgeClass(app.status)">
                  <span class="status-dot"></span>{{ statusLabel(app.status) }}
                </span>
                <!-- <span class="status-desc">{{ statusDescription(app.status) }}</span> -->
              </div>
            </td>
            <td>
              <span *ngIf="app.offerStatus !== null && app.offerStatus !== undefined" class="status-badge"
                [ngClass]="offerBadgeClass(app.offerStatus)">
                <span class="status-dot"></span>{{ offerStatusLabel(app.offerStatus) }}
              </span>
              <span *ngIf="app.offerStatus === null || app.offerStatus === undefined" class="td-decision">—</span>
            </td>
            <td>
              <a *ngIf="hasHistory(app)" class="link-history" (click)="openHistory(app)">View History</a>
              <span *ngIf="!hasHistory(app)" class="td-dash">—</span>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6">
              <div class="p-4 text-center text-500">
                No applications in this phase.
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-container>

  <!-- Empty State View -->
  <div class="empty-applications-state" *ngIf="applications.length === 0 && !isLoading">
    <div class="empty-illustration">
      <img src="assets/images/dashboard_college.svg" alt="Discover Universities" />
    </div>
    <p class="empty-message">
      Start exploring universities and take the first step toward your High-Ed journey.<br />
      Your applications will appear here once you get started.
    </p>
    <button pButton class="discover-btn border-none" routerLink="/portal/institute-search">
      Discover Universities <i class="pi pi-arrow-right ml-2" style="font-size: 0.9rem;"></i>
    </button>
  </div>

  <!-- View History dialog (read-only for students — pencil edit hidden) -->
  <app-application-history-dialog #historyDialog [canEdit]="false"></app-application-history-dialog>

</div>